export { default as BundleProductCardPriceAndTitleV2DS } from './bundle-product-card-price-and-title-v2-ds'
